import React, { useEffect } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { useNavigate } from 'react-router-dom';
import AdminLayout from './layouts/AdminLayout';
import Users from './admin/Users';

const Dashboard: React.FC = () => {
  const { user, isAdmin } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    // Se è admin, reindirizza alla sezione utenti
    if (isAdmin()) {
      navigate('/admin/utenti', { replace: true });
    } else {
      // Se è utente normale, reindirizza alla sezione genera buono
      navigate('/admin/genera-buono', { replace: true });
    }
  }, [isAdmin, navigate]);

  // Se è admin, mostra la sezione utenti (verrà reindirizzato)
  if (isAdmin()) {
    return (
      <AdminLayout activeSection="utenti">
        <Users />
      </AdminLayout>
    );
  }

  // Per utenti normali, mostra una dashboard con layout
  return (
    <AdminLayout activeSection="genera-buono">
      <div className="admin-content">
        <div className="content-header mb-4">
          <div>
            <h1 className="content-title">Benvenuto, {user?.name}</h1>
            <p className="content-subtitle">Dashboard utente</p>
          </div>
        </div>
      </div>
    </AdminLayout>
  );
};

export default Dashboard;
